export default {
  navigationTitle: 'Line of Credit',
  qualificationCheck: {
    title: 'Let’s quickly see if you qualify',
    instruction:
      'Please confirm your information. We’ll see if you qualify for Varo Line of Credit.',
    listItems: {
      legalName: 'Legal name',
      homeAddress: 'Home address',
      ssn: 'SSN',
      dateOfBirth: 'Date of birth',
    },
    disclaimer:
      'By tapping “Confirm”, I authorize Varo to obtain a consumer report to see if I qualify for Varo Line of Credit. I understand this pull will not impact my credit score.',
    buttons: {
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
  },
  approved: {
    buttons: {
      borrowNow: 'Borrow now',
      borrowLater: 'Borrow later',
    },
  },
  moneyInTheBank: {
    button: 'Done',
  },
  confirmPayment: {
    amountLabel: 'Payment amount',
    repayLabel: 'Repay from',
    buttonTitle: 'Confirm payment',
    exceptionalError: 'Oops! Something went wrong. Please try again later',
  },
  notQualified: {
    buttons: {
      openBelieve: 'Open Varo Believe Account',
      done: 'Done',
    },
  },
  creditFrozen: {
    button: 'Done',
  },
  vlocTakeOut: {
    button: 'Grow your borrowing power',
  },
  triesData: {
    term: 'Term',
    monthlyPayment: 'Monthly payment',
    fee: 'Fee',
    close: 'Close',
  },
  applyEmployment: {
    title: 'Apply',
    subTitle:
      'Almost there! Answer a couple questions to apply for Varo Line of Credit.',
    employmentStatus: 'What’s your employment status?',
    monthlyIncome: 'What’s your average monthly income (before taxes)?',
    annualIncomeEstimate: 'Approximate annual income',
    whatCountsAsIncome: 'What counts as income?',
    agreeAndAcknowledge:
      'I agree and acknowledge receipt of the Varo ' +
      'Line of Credit Agreement and Disclosures and authorize Varo to ' +
      'obtain my credit report from Trans Union for this application which' +
      ' may impact my credit score. I agree to ',
    termsAndConditions: 'Varo Line of Credit Terms and Conditions',
    checkboxAriaLabel: 'Credit check agreement',
    incomeDescription:
      'Your income includes total wages, salaries (including commissions, ' +
      'bonuses, and tips), retirement, and government assistance. \n\n' +
      'You do not need to include alimony, child support, or separate ' +
      'maintenance income, unless you want us to have it considered ' +
      'as a basis for repaying this line of credit.',
    buttons: {
      primary: 'Submit',
      secondary: 'Cancel',
      gotIt: 'Got it',
    },
  },
  review: {
    listItems: {
      fee: 'Fee',
      total: 'Total',
      term: 'Term',
      paymentAmount: 'Payment amount',
      firstPaymentDue: 'First payment due',
    },
    whatIsAutoPay: 'What is AutoPay?',
    lineOfCreditAmount: 'Line of Credit amount',
    preferNotToMakePayment:
      'If you prefer not to make payments using your Varo Bank Account,you can',
    instead: 'instead.',
    payByCheck: ' pay by check ',
    buttons: {
      gotIt: 'Got it',
      getLineOfCredit: 'Get Line of Credit',
      cancel: 'Cancel',
    },
  },
  paymentSchedule: {
    paidToDate: 'Paid to date',
    remainingBalance: 'Remaining balance',
    header: 'Payment Schedule',
    ACTIVE: 'Payment due',
    DELINQUENT: 'Payment overdue',
    PAID: 'Paid',
    REVERSED: 'Reversed',
    UNDEFINED_INSTALLMENT_STATE: 'Undefined',
  },
  error: {
    title: 'Oops, something went wrong',
    subTitle: 'Please try again later.',
    button: 'Done',
  },
  manageAccount: {
    screenTitle: 'Manage Account',
    autoPay: 'AutoPay',
    varoLineOfCreditHistory: 'Varo Line of Credit History',
    statementsAndDocuments: 'Statements and documents',
    helpSectionHeader: 'Help',
    manageAccountHeader: 'Manage Account',
    whatIsVaroLineOfCredit: 'What is Varo Line of Credit?',
    varoLineCreditFaqs: 'Varo Line of Credit FAQs',
    termsAndConditions: 'Terms and Conditions',
    autopayStatus: {
      on: 'On',
      off: 'Off',
    },
  },
  activeScreen: {
    title: 'Line of Credit',
    amountDue: 'Amount due',
    dueDate: 'Due Date',
    autoPay: 'AutoPay',
    autoPayStatus: {
      on: 'On',
      off: 'Off',
    },
    makePayment: 'Make a payment',
    remainingBalance: 'Remaining balance',
    paymentSchedule: 'Payment schedule',
  },
  crunchingTheNumbers: {
    title: 'Crunching the numbers...',
    subTitle: 'Stay on this page and give us just a moment to wrap up.',
  },
  history: {
    header: 'Line of Credit history',
    itemTitle: 'Varo Line of Credit',
    noHistoryTitle: 'No history',
    noHistorySubTitle: 'Your activity will be shown here',
  },
  vlocGeneral: {
    lineOfCreditTitle: 'Line of Credit',
  },
  repaymentSuccess: {
    pendingAmount: '$150.00',
    button: 'Done',
  },
  historyDetails: {
    title: 'Line of Credit details',
    payment: 'Payment',
  },
  vlocIsOnItsWay: {
    button: 'Done',
  },
  transactionDetails: {
    header: 'Transaction details',
    description: 'Description',
    fromAccount: 'From account',
    toAccount: 'To account',
    requestedOn: 'Requested on',
    status: 'Status',
  },
  repaymentDetails: {
    available: 'Available:',
    buttonLabel: 'Next',
    from: 'From:',
    limitErrorStart: 'You will owe {{pendingAmount}} on {{paymentDueDate}}',
    navigationTitle: 'Repay Line of Credit',
    selectAnAccount: 'Select an account',
    moreThanAmountDue:
      'You’re paying more than the amount due. We’ll apply the excess funds to the last payment of your payment schedule.',
    moreThanOutstandingBalance:
      'This amount is more than your total Line of Credit balance due.',
    notEnoughFunds:
      'You don’t have enough funds in your bank account for this amount.',
    payingOff: 'You’re paying off your total Line of Credit balance.',
    loading: 'Loading...',
  },
  autoPay: {
    header: 'AutoPay',
    onTitle: 'AutoPay is on',
    offTitle: 'AutoPay is off',
    onBody:
      'AutoPay is on. Your monthly statement balance is fully paid on time.',
    offBody:
      'AutoPay is off. Turn it on to automatically pay your full monthly statement balance.',
    onButton: 'Turn on AutoPay',
    offButton: 'Turn off AutoPay',
    bottomSheetTitle: 'Turn off AutoPay?',
    bottomSheetBody:
      'AutoPay pays your Varo Line of Credit statement every month.\n\n' +
      ' Leave AutoPay on to avoid late payments that can negatively impact your credit.',
    bottomSheetOnButton: 'Leave AutoPay on',
    bottomSheetOffButton: 'Turn AutoPay off',
  },
};
